export const range = (start: number, stop: number): number[] =>
  Array(Math.ceil(stop - start))
    .fill(start)
    .map((x, y) => x + y);
